import React, { Component } from "react";
import DeckList from "./Decklist";
import { Button, Badge, Collapse } from 'reactstrap';

class DeckBuilderAside extends Component {

  constructor(props, context) {
  super(props, context);
    this.state = {
      isOpen: true
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }


  render() {
    var asideStyle = {
      order: 2,
      width:"30%",
    };

    var deckListStyle = {
      marginTop:"50px"
    };

    return (
        <aside style={asideStyle} className="Site_Content">
        <div id="deck" style={deckListStyle} >
        <Collapse id="collapseExample" className="navbar-dark bg-dark" isOpen={this.state.isOpen}>
          <DeckList decklist={this.props.decklist} deckcount={this.props.deckcount} cardPreview={this.props.cardPreview}
          clickHandler={this.props.clickHandler} deckDetailsHandler={this.props.deckDetailsHandler} nanoCost={this.props.nanoCost}
          preview={this.props.preview} previewCard={this.props.previewCard} />
        </Collapse>
        <button type="button" className="btn" onClick={this.props.deckDetailsHandler} >Deck Details</button>

         <button className="btn btn-primary" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
  Button with data-target
</button>

          <Button data-target="#decklist" data-toggle="collapse" color="primary" onClick={this.toggle} >
            Collapse <Badge color="secondary">{this.props.deckcount}</Badge>
          </Button>
        </div>
        </aside>
    );
  }
}

export default DeckBuilderAside;



// WEBPACK FOOTER //
// ./src/DeckBuilderComponents/DeckBuilderAside.js